import React from 'react';
import { Chip, Tooltip } from '@mui/material';

// Marks a row from a test school (backend TEST_SCHOOL_IDS — every admin list
// route tags those rows isTest: true). Only the site admin ever receives
// test-school rows (other admins get them filtered out server-side); they're
// left out of every total/count, so this tag explains why a row isn't adding up.
export default function TestSchoolChip({ sx }) {
  return (
    <Tooltip title="Test school — shown here, but not included in any totals or counts">
      <Chip size="small" label="Test" color="secondary" variant="outlined"
        sx={{ ml: 0.75, height: 18, fontSize: 11, verticalAlign: 'middle', ...sx }} />
    </Tooltip>
  );
}
